import { render, staticRenderFns } from "./recommendedSettings.vue?vue&type=template&id=7bd1e937&scoped=true"
import script from "./recommendedSettings.vue?vue&type=script&lang=js"
export * from "./recommendedSettings.vue?vue&type=script&lang=js"
import style0 from "./recommendedSettings.vue?vue&type=style&index=0&id=7bd1e937&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1e937",
  null
  
)

export default component.exports